module.exports = __webpack_public_path__ + "img/wa.4d16e9fb.svg";